import Container from "../Container";
import FooterContacts from "../FooterContacts";
import FooterHeader from "../FooterHeader";
import FooterImageFile from "../../statics/img/footer.jpg";
import FooterNav from "../FooterNav";
import React from "react";

const Footer = () => {
  return (
    <div
      className="w-full py-12 bg-gray-100 bg-bottom bg-no-repeat bg-contain lg:bg-cover"
      style={{
        backgroundImage: `url(${FooterImageFile})`,
      }}
    >
      <Container>
        <div className="flex flex-wrap justify-start">
          <div className="w-full my-4 lg:w-4/12">
            <FooterHeader />
          </div>
          <div className="w-full my-4 lg:px-8 lg:w-4/12">
            <FooterNav />
          </div>
          <div className="w-full my-4 lg:w-4/12">
            <FooterContacts />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
